<template>
  <div class="border-r w-64 mr-2 pr-14 text-right font-semibold text-gray-800">
    <div
      v-if="selectedTab === 'Summary'"
      class="h-4"
    />
    <div
      v-else
      class="h-12"
    />

    <div
      v-if="selectedTab === 'Summary'"
      class="py-1 font-normal"
    >
      <span class="inline-block w-4 h-5" />
    </div>

    <div class="py-2">
      <div
        v-if="selectedTab === 'Summary'"
        class="flex items-center justify-end -mr-6 text-gray-800 hover:text-gray-600 cursor-pointer transition-all duration-500 select-none"
        @click="emitToggle('openAvgTotalCostBreakdown', !openAvgTotalCostBreakdown)"
      >
        <div>Average cost</div>
        <div
          class="w-6 text-right text-xs"
          style="margin-top: 2px"
        >
          <i
            v-if="!openAvgTotalCostBreakdown"
            class="fas fa-plus"
          />
          <i
            v-else
            class="fas fa-minus"
          />
        </div>
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalCostBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.partnershipFee"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Partnership fee
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalCostBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="softwareTooltip"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Software cost
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalCostBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.cardFees"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Card fees
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalCostBreakdown"
        class="font-normal flex items-center justify-end -mr-6 text-gray-800 hover:text-gray-600 cursor-pointer transition-all duration-500 select-none"
        @click="emitToggle('openPayrollBreakdown', !openPayrollBreakdown)"
      >
        <div>Payroll</div>
        <span
          class="w-6 text-right text-xs"
          style="margin-top: 2px"
        >
          <i
            v-if="!openPayrollBreakdown"
            class="fas fa-plus"
          />
          <i
            v-else
            class="fas fa-minus"
          />
        </span>
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalCostBreakdown && openPayrollBreakdown"
        class="font-normal text-gray-500"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.payrollCustomerService"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Customer services
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalCostBreakdown && openPayrollBreakdown"
        class="font-normal text-gray-500"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.payrollRenewals"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Renewals
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalCostBreakdown && openPayrollBreakdown"
        class="font-normal text-gray-500"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.payrollOnboarding"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Onboarding
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalCostBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.digitalMarketing"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Digital Marketing
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalCostBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.otherMarketing"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Other marketing
      </div>

      <div
        v-if="selectedTab === 'Profit'"
        class="text-gray-500 font-normal"
      >
        <div
          class="inline-block mr-1 w-3 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="maximumText"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Maximum
      </div>

      <div
        v-if="selectedTab === 'ROI'"
        class="text-gray-500 font-normal"
      >
        <div
          class="inline-block mr-1 w-3 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="maximumText"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Maximum
      </div>

      <div
        v-if="selectedTab === 'Revenue'"
        class="flex items-center justify-end -mr-6 text-gray-800 hover:text-gray-600 cursor-pointer transition-all duration-500 select-none"
        @click="emitToggle('openNewMemberGrowthBreakdown', !openNewMemberGrowthBreakdown)"
      >
        <div>New Member growth</div>
        <div
          class="w-6 text-right text-xs"
          style="margin-top: 2px"
        >
          <i
            v-if="!openNewMemberGrowthBreakdown"
            class="fas fa-plus"
          />
          <i
            v-else
            class="fas fa-minus"
          />
        </div>
      </div>

      <div
        v-if="selectedTab === 'Revenue' && openNewMemberGrowthBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.newMembersCount"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        No Members
      </div>

      <div
        v-if="selectedTab === 'Revenue' && openNewMemberGrowthBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.newMembersRevenue"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        New members revenue
      </div>
    </div>

    <div class="py-2">
      <div
        v-if="selectedTab === 'Summary'"
        class="flex items-center justify-end -mr-6 text-gray-800 hover:text-gray-600 cursor-pointer transition-all duration-500 select-none"
        @click="emitToggle('openAvgTotalRevenueBreakdown', !openAvgTotalRevenueBreakdown)"
      >
        <div>Average revenue</div>
        <div
          class="w-6 text-right text-xs"
          style="margin-top: 2px"
        >
          <i
            v-if="!openAvgTotalRevenueBreakdown"
            class="fas fa-plus"
          />
          <i
            v-else
            class="fas fa-minus"
          />
        </div>
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalRevenueBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.retainedRevenue"
        >
          <i
            class="fad fa-info-circle text-sm text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Member retention
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalRevenueBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.growthRevenue"
        >
          <i
            class="fad fa-info-circle text-sm text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Member growth
      </div>

      <div
        v-if="selectedTab === 'Summary' && openAvgTotalRevenueBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.flexiRevenueTotal"
        >
          <i
            class="fad fa-info-circle text-sm text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Flexi revenue
      </div>

      <div
        v-if="selectedTab === 'Profit'"
        class="text-xl"
      >
        <div
          class="inline-block mr-1 w-4 text-base text-center font-normal"
          style="z-index: 15 !important"
          :data-tooltip="tooltips.averageProfit"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Average
      </div>

      <div
        v-if="selectedTab === 'ROI'"
        class="text-xl"
      >
        <div
          class="inline-block mr-1 w-4 text-base text-center font-normal"
          style="z-index: 15 !important"
          :data-tooltip="tooltips.averageRoi"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Average
      </div>

      <div
        v-if="selectedTab === 'Revenue'"
        class="flex items-center justify-end -mr-6 text-gray-800 hover:text-gray-600 cursor-pointer transition-all duration-500 select-none"
        @click="emitToggle('openMemberRetentionBreakdown', !openMemberRetentionBreakdown)"
      >
        <div>Member retention</div>
        <div
          class="w-6 text-right text-xs"
          style="margin-top: 2px"
        >
          <i
            v-if="!openMemberRetentionBreakdown"
            class="fas fa-plus"
          />
          <i
            v-else
            class="fas fa-minus"
          />
        </div>
      </div>

      <div
        v-if="selectedTab === 'Revenue' && openMemberRetentionBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.renewingMembersCount"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        No member renewing
      </div>

      <div
        v-if="selectedTab === 'Revenue' && openMemberRetentionBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.renewingMembersRevenue"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Retention Revenue
      </div>
    </div>

    <!-- ========== MINIMUMS / TOTAL MEMBERS / FLEXI REV ========= -->
    <div class="py-2">
      <div v-if="selectedTab === 'Summary'">
        Average profit
      </div>

      <div
        v-if="selectedTab === 'Costs'"
        class="text-gray-500 font-normal"
      >
        <div
          class="inline-block mr-1 w-3 text-sm text-center"
          style="z-index: 10 !important"
          :data-tooltip="tooltips.partnershipFee"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Partnership fee
      </div>

      <div
        v-if="selectedTab === 'Profit'"
        class="text-gray-500 font-normal"
      >
        <div
          class="inline-block mr-1 w-5 text-center"
          style="z-index: 10 !important"
          :data-tooltip="minimumText"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Minimum
      </div>

      <div
        v-if="selectedTab === 'ROI'"
        class="text-gray-500 font-normal"
      >
        <div
          class="inline-block mr-1 w-5 text-center"
          style="z-index: 10 !important"
          :data-tooltip="minimumText"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Minimum
      </div>

      <div
        v-if="selectedTab === 'Revenue'"
        class="flex items-center justify-end -mr-6 text-gray-800 hover:text-gray-600 cursor-pointer transition-all duration-500 select-none"
        @click="emitToggle('openTotalHomeClubMembersBreakdown', !openTotalHomeClubMembersBreakdown)"
      >
        <div>Total Home Club Members</div>
        <div
          class="w-6 text-right text-xs"
          style="margin-top: 2px"
        >
          <i
            v-if="!openTotalHomeClubMembersBreakdown"
            class="fas fa-plus"
          />
          <i
            v-else
            class="fas fa-minus"
          />
        </div>
      </div>

      <div
        v-if="selectedTab === 'Revenue' && openTotalHomeClubMembersBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.membersTotal"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Members
      </div>

      <div
        v-if="selectedTab === 'Revenue' && openTotalHomeClubMembersBreakdown"
        class="font-normal"
      >
        <div
          class="inline-block mr-1 w-2 text-sm text-center"
          style="z-index: 20 !important"
          :data-tooltip="tooltips.membersRevenueTotal"
        >
          <i
            class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
          />
        </div>
        Revenue
      </div>
    </div>

    <div v-if="selectedTab === 'Revenue'">
      <div
        class="inline-block mr-1 w-2 text-sm text-center"
        style="z-index: 20 !important"
        :data-tooltip="tooltips.flexiRevenueTotal"
      >
        <i
          class="fad fa-info-circle text-gray-600 hover:text-gray-800 duration-500 transition-all cursor-pointer"
        />
      </div>
      Flexi revenue
    </div>

    <div
      v-if="selectedTab === 'Profit' && showRiskOfLoss"
      class="py-2 font-normal text-gray-500"
    >
      <div>Risk of loss</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MetricLabels',
    props: {
      selectedTab: { type: String, required: true },
      yearIndex: { type: Number, default: 0 },

      openAvgTotalCostBreakdown: { type: Boolean, default: false },
      openPayrollBreakdown: { type: Boolean, default: false },
      openAvgTotalRevenueBreakdown: { type: Boolean, default: false },
      openNewMemberGrowthBreakdown: { type: Boolean, default: false },
      openMemberRetentionBreakdown: { type: Boolean, default: false },
      openTotalHomeClubMembersBreakdown: { type: Boolean, default: false },

      existingFlexibleMembership: { type: Boolean, default: false },
      showRiskOfLoss: { type: Boolean, default: false },
    },
    computed: {
      softwareTooltip() {
        return this.existingFlexibleMembership
          ? 'The total cost for the software you currently use to manage your own flexible membership.'
          : 'The total cost for software to manage your own flexible membership.';
      },
      maximumText() {
        return 'The maximum value that was achieved out of the 20,000 simulations.';
      },
      averageText() {
        return 'The average value that was achieved from the 20,000 simulations.';
      },
      minimumText() {
        return 'The minimum value that was achieved out of the 20,000 simulations.';
      },
      tooltips() {
        return {
          partnershipFee: 'The price of your partnership fee with PlayMoreGolf.',
          cardFees: 'The average total amount of fees charged for processing card transactions.',
          payrollCustomerService: 'The payroll costs associated with providing a customer service.',
          payrollRenewals: 'The payroll costs associated with renewing your current members.',
          payrollOnboarding: 'The payroll costs associated with onboarding new members.',
          digitalMarketing:
            'Your total yearly cost on social media including paid adverts/boosted posts and agency costs.',
          otherMarketing:
            'Your total yearly cost for all other marketing activities including printed adverts, design work etc.',
          newMembersCount: 'The number of new members.',
          newMembersRevenue: 'The revenue from new members.',
          retainedRevenue:
            'The total average revenue received from retained members over the next 12 months(after commission for PMG).',
          growthRevenue:
            'The total average revenue received from membership growth over the next 12 months(after commission for PMG).',
          flexiRevenueTotal:
            'The total amount of flexi revenue received from PlayMoreGolf members over the next 12 months',
          averageTotalCost:
            'The average total sum of license/partnership fees, marketing spend, onboarding cost, renewal cost and customer service cost.',
          averageProfit: 'The average profit value that was achieved from the 20,000 simulations.',
          averageRoi: 'The average ROI value that was achieved from the 20,000 simulations.',
          renewingMembersCount: 'The number of renewing members.',
          renewingMembersRevenue: 'The revenue from renewing members.',
          membersTotal: 'The number of all members.',
          membersRevenueTotal: 'Total revenue from members.',
        };
      },
    },
    methods: {
      emitToggle(propName, nextVal) {
        this.$emit(`update:${propName}`, nextVal);
      },
    },
  };
</script>
